import axios from '@/utils/request'
var Qs = require('qs')

export default {
    // 2020-08-21
    vagueFindBySerialNoOrName(params) {
        return axios.get('/mms/materials/vague-find-by-serial-no-or-name', params)
    },

    // 2021-01-03
    search(params) {
        return axios.get('/mms/materials?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    // 2021-01-03
    exportExcel(params) {
        return axios.get('/mms/materials/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
    },
    // 2021-01-03
    delete(id) {
        return axios.delete('/mms/materials/' + id)
    },
    // 2021-01-03
    findBySerialNo(params) {
        return axios.get('/mms/materials/find-by-serial-no', params)
    },
    // 2021-01-03
    getNames() {
        return axios.get('/mms/materials/all-name')
    },
    // 2021-01-03
    getUnits() {
        return axios.get('/mms/materials/all-unit')
    },
    // 2021-09-03
    getInUnits() {
        return axios.get('/mms/materials/all-in-unit')
    },
    // 2021-01-03
    insertBatch(params) {
        return axios.post('/mms/materials/insert-batch', params)
    },
    // 2021-01-03
    update(id, params) {
        return axios.put('/mms/materials/' + id, params)
    },
    // 2021-01-16
    statistics(params) {
        return axios.put('/mms/materials/statistics', params);
    },
    // 2021-01-26
    onWayStatistics() {
        return axios.get('/mms/materials/on-way-statistics');
    },
    // 2021-09-14
    repeatCount() {
        return axios.get('/mms/materials/repeat-count')
    },
    // 2021-12-28
    lackStatistics(params) {
        return axios.get('/mms/materials/lack-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
    },
    // // 2023-04-14
    // lackStatistics(params) {
    //     return axios.get('/mms/materials/lack-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
    // },
    // 2021-12-28
    lackStatisticsCount() {
        return axios.get('/mms/materials/lack-statistics-count')
    },

    // 2023-04-22
    calcLackStatistics() {
        return axios.get('/mms/materials/calc-lack-statistics')
    },

    // 2023-04-25
    lackStatisticsTotalInfo() {
        return axios.get('/mms/materials/lack-statistics-total-info')
    },
    // 2022-01-18
    materialSuppliersfindById(id) {
        return axios.get('/mms/materials/' + id + '/suppliers')
    },
    // 2022-01-18
    createMaterialSupplier(params) {
        return axios.post('/mms/materials/suppliers/insert-batch', params)
    },
    // 2022-01-18
    updateMaterialSupplier(materialSupplierId, params) {
        return axios.put('/mms/materials/suppliers/' + materialSupplierId, params)
    },

    //  2022-01-18
    deleteMaterialSupplier(materialSupplierId) {
        return axios.delete('/mms/materials/suppliers/' + materialSupplierId)
    },
    //  2022-01-18
    updateDefaultSupplier(id, materialSupplierId) {
        return axios.put('/mms/materials/' + id + '/suppliers/' + materialSupplierId + '/update-default-supplier')
    },
    //  2022-04-28
    updateHandCycleBySubject(params) {
        return axios.put('/mms/materials/update-hand-cycle-by-subject', params)
    },
    //  2022-06-27
    updateHandCycleBySupplier(params) {
        return axios.put('/mms/materials/update-hand-cycle-by-supplier', params)
    },

    //  2023-03-27
    mapping(params) {
        return axios.put('/mms/materials/mapping', params)
    },
    //  2023-03-27
    clearMapping(id, params) {
        return axios.put('/mms/materials/' + id + '/clear-mapping', params)
    },
    // 2021-01-03
    findById(id) {
        return axios.get('/mms/materials/' + id)
    }

}

